import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _get from 'babel-runtime/helpers/get';
import _inherits from 'babel-runtime/helpers/inherits';
import { UpModule } from './upmodule';
import ResultInt from '../../_interface/result-int';
export var UpTrace = function (_UpModule) {
    _inherits(UpTrace, _UpModule);

    function UpTrace(plugin) {
        _classCallCheck(this, UpTrace);

        // 保留页面打点统计数据
        var _this = _possibleConstructorReturn(this, (UpTrace.__proto__ || Object.getPrototypeOf(UpTrace)).call(this, plugin));

        _this.pageTrackObj = {};
        // 私有属性，保留domObserver
        _this.domObserver = null;
        return _this;
    }

    _createClass(UpTrace, [{
        key: 'reportSelfPageChange',
        value: function reportSelfPageChange(param) {
            return this.generatePromiseByPluginFunctionWithParams('reportSelfPageChange', param);
        }
    }, {
        key: 'reportPageClickEvent',
        value: function reportPageClickEvent(param) {
            return this.generatePromiseByPluginFunctionWithParams('reportPageClickEvent', param);
        }
    }, {
        key: 'statPageEventData',
        value: function statPageEventData(param) {
            if (param && !param.pageName) {
                param.pageName = this.pageTrackObj.pageName || window.location.href;
            }
            if (typeof window.consoleLog === 'function') {
                window.consoleLog('打点信息--', param);
            }
            return this.generatePromiseByPluginFunctionWithParams('statPageEventData', param);
        }
    }, {
        key: 'reportTraceEvent',
        value: function reportTraceEvent(param) {
            return this.generatePromiseByPluginFunctionWithParams('reportTraceEvent', param);
        }
    }, {
        key: 'reportPageExposureEvent',
        value: function reportPageExposureEvent(param) {
            return this.generatePromiseByPluginFunctionWithParams('reportPageExposureEvent', param);
        }
    }, {
        key: 'savePageCommonEvent',
        value: function savePageCommonEvent(param) {
            return this.generatePromiseByPluginFunctionWithParams('savePageCommonEvent', param);
        }
    }, {
        key: 'getErrorCodeAndText',
        value: function getErrorCodeAndText(_code) {
            if (_code === '210001') {
                return { msg: '传入参数为空或者错误', code: '000002' };
            }
            return _get(UpTrace.prototype.__proto__ || Object.getPrototypeOf(UpTrace.prototype), 'getErrorCodeAndText', this).call(this, _code);
        }
    }, {
        key: 'gioTrack',
        value: function gioTrack(param) {
            var self = this;
            document.container.upLogModule.printParameters('gioTrack', param);
            return new Promise(function (resolve, reject) {
                self.rejectIfNoPlugin(reject);
                self.plugin.gioTrack(param, function (result) {
                    if (result.retCode === '000000') {
                        document.container.upLogModule.printSucceedResult('gioTrack', result);
                        resolve(new ResultInt('000000', 'gioTrack接口调用成功', result.retData));
                    } else {
                        document.container.upLogModule.printFailResult('gioTrack', result);
                        reject(new ResultInt('000002', 'eventId参数为空', result.retData));
                    }
                });
            });
        }
    }, {
        key: 'gioTrackWithVariable',
        value: function gioTrackWithVariable(param) {
            document.container.upLogModule.printParameters('gioTrackWithVariable', param);
            var self = this;
            return new Promise(function (resolve, reject) {
                self.rejectIfNoPlugin(reject);
                self.plugin.gioTrackWithVariable(param, function (result) {
                    if (result.retCode === '000000') {
                        document.container.upLogModule.printSucceedResult('gioTrackWithVariable', result);
                        resolve(new ResultInt('000000', 'gioTrackWithVariable接口调用成功', result.retData));
                    } else {
                        document.container.upLogModule.printFailResult('gioTrackWithVariable', result);
                        reject(new ResultInt('000002', '参数为空', result.retData));
                    }
                });
            });
        }
    }]);

    return UpTrace;
}(UpModule);